export default __webpack_public_path__ + "static/media/stonkMarket.6635a1d7.png";